import { makeStyles } from '@material-ui/styles';

export default makeStyles({
    hiddenThumb: {
        display: 'none',
    },
});
